import Phaser from 'phaser';
import './styles/ponpon.css';
import { BootScene, SCENE_BACKGROUND, GAME_SIZE } from './scenes/BootScene.js';
import { SplashScene } from './scenes/SplashScene.js';
import { RoomBrowserScene } from './scenes/RoomBrowserScene.js';
import { LobbyScene } from './scenes/LobbyScene.js';
import { StageScene } from './scenes/StageScene.js';
import { gameplayMusic } from './audio/gameplayMusic.js';

/**
 * Client entrypoint. Boots a Phaser game scaled to the prototype's landscape
 * screen size into `#app`. The menu/lobby scenes (Splash, Room Browser, Lobby)
 * are DOM-overlay scenes, so the Phaser DOM container is enabled. Scenes live
 * in `src/scenes/`; shared contracts come from `@ponponland/shared`; visual
 * tokens from `src/config/theme.ts` (mirrored in `src/styles/ponpon.css`); the
 * reusable world components live in `src/world/` (see its README).
 */
new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'app',
  backgroundColor: SCENE_BACKGROUND,
  dom: {
    createContainer: true,
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_SIZE.width,
    height: GAME_SIZE.height,
  },
  scene: [BootScene, SplashScene, RoomBrowserScene, LobbyScene, StageScene],
});

gameplayMusic.start();
